import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function Nilai({ data }) {
  return (
    <section className="flex -md:flex-col-reverse md:justify-end space-x-5 items-start mt-20">
      <div className="md:w-1/2 -md:container flex flex-col md:pt-10">
        <ScrollAnimation animateOnce={true} animateIn="fadeInLeft">
          <div className="flex space-x-4 items-center">
            <h1 className="md:text-6xl text-lg text-yellow italic font-black">
              {data.title}
            </h1>
            <div className="bg-purple md:w-64 md:h-4 -md:h-1 -md:w-11"></div>
          </div>
          <h2 className="-md:text-sm md:text-4xl italic font-medium text-purple">
            {data.subtitle}
          </h2>
          <p
            className="md:text-2xl -md:text-xs -md:mt-2 font-medium md:mt-12"
            dangerouslySetInnerHTML={{
              __html: `${data.description}`,
            }}
          />
        </ScrollAnimation>
      </div>
      <div className="md:w-1/3">
        <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
          <img
            className="md:w-full -md:w-10/12 ml-auto"
            src={data.image}
            alt="Asset"
          />
        </ScrollAnimation>
      </div>
    </section>
  );
}
